var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faAnglesLeft, faAnglesRight, faArrowUpShortWide, faEllipsisH, faFilter, faShareNodes, faSort, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import isEqual from "react-fast-compare";
import { getConfigVar } from "../../utils/Configuration";
import { EmptyComponent } from "../../utils/EmptyComponent";
import { concatClassNames, filterChildrenOfType, range } from "../../utils/Functions";
import { Checkbox } from "../form/Checkbox";
import { Datepicker } from "../form/Datepicker";
import { Input } from "../form/Input";
import { Timepicker } from "../form/Timepicker";
import { Button } from "./Button";
import { Dropdown } from "./Dropdown";
import { Tooltip } from "./Tooltip";
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps) {
            var _a, _b;
            if (((_a = prevProps.data) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = _this.props.data) === null || _b === void 0 ? void 0 : _b.length) && !_this.showPagination() && _this.state.page > 1)
                _this.setState({ page: 1 });
            if (!isEqual(prevProps.data, _this.props.data) && _this.props.isSelectedDefault) {
                var _c = _this.props, data = _c.data, isSelectedDefault_1 = _c.isSelectedDefault, checkedItems = data.map(function (item, index) { return ({ item: item, index: index }); }).filter(function (_a) {
                    var item = _a.item;
                    return isSelectedDefault_1(item);
                }).map(function (_a) {
                    var index = _a.index;
                    return index;
                });
                _this.setState({ checkedItems: checkedItems });
            }
        };
        _this.changeSelection = function (index) {
            var _a = _this.props, data = _a.data, selectionMode = _a.selectionMode, isSelectable = _a.isSelectable, onSelectionChange = _a.onSelectionChange, checkedItems = _this.state.checkedItems;
            var newElements = [];
            if (isSelectable && !isSelectable(data[index]))
                return;
            if (checkedItems.includes(index))
                newElements = checkedItems.filter(function (d) { return d !== index; });
            else
                newElements = selectionMode === "multiple" ? checkedItems.concat(index) : [index];
            _this.setState({ checkedItems: newElements });
            if (onSelectionChange)
                onSelectionChange(data.filter(function (_, i) { return newElements.includes(i); }));
        };
        _this.checkAll = function () {
            var checkedItems = _this.state.checkedItems, _a = _this.props, onSelectionChange = _a.onSelectionChange, data = _a.data, isSelectable = _a.isSelectable, selectableItems = data.map(function (item, index) { return ({ item: item, index: index }); }).filter(function (d) { return !isSelectable || isSelectable(d.item); });
            var newItems = [];
            if (checkedItems.length !== selectableItems.length)
                newItems = selectableItems.map(function (d) { return d.index; });
            _this.setState({ checkedItems: newItems });
            if (onSelectionChange)
                onSelectionChange(data.filter(function (_, i) { return newItems.includes(i); }));
        };
        _this.checkContainerScroll = function () {
            var header = _this.target.querySelector("table thead tr:last-child"), check = _this.target.scrollTop > header.offsetHeight, check2 = Math.ceil(_this.target.scrollTop) >= (_this.target.scrollHeight - _this.target.offsetHeight), scrollEnded = _this.state.scrollEnded;
            if (check && !header.classList.contains("overflow"))
                header.classList.add("overflow");
            else if (!check && header.classList.contains("overflow"))
                header.classList.remove("overflow");
            if (scrollEnded !== check2)
                _this.setState({ scrollEnded: check2 });
        };
        _this.changePage = function (page) { return _this.setState({ page: page }); };
        _this.getPaginationButtons = function () {
            var pagination = _this.props.pagination, page = _this.state.page, data = _this.getFilteredData(), pages = Math.ceil(data.length / pagination), remain = pages - page, next = remain > 3 ? 3 : remain, prev = page > 3 ? 3 : page > 1 ? page - 1 : 0;
            return React.createElement(React.Fragment, null,
                page > 1 && React.createElement(Tooltip, { label: getConfigVar("FIRST_PAGE") },
                    React.createElement(Button, { shape: "pill", color: "white", onClick: function () { return _this.changePage(1); } },
                        React.createElement(FontAwesomeIcon, { icon: faAnglesLeft }))),
                page > 4 && React.createElement(Dropdown, { key: "prev_" + page, options: range(1, page - 3).map(function (n) { return ({
                        children: getConfigVar("PAGE") + " " + n,
                        onClick: function () { return _this.changePage(n); }
                    }); }) },
                    React.createElement(Tooltip, { label: getConfigVar("PAGES") },
                        React.createElement(Button, { shape: "pill", color: "white" },
                            React.createElement(FontAwesomeIcon, { icon: faEllipsisH })))),
                prev > 0 && range(page - prev, page).map(function (n) { return React.createElement(Button, { key: n, shape: "pill", color: "white", onClick: function () { return _this.changePage(n); } }, n); }),
                React.createElement(Button, { shape: "pill", color: "blue2" }, page),
                next > 0 && range(page + 1, page + next + 1).map(function (n) { return React.createElement(Button, { key: n, shape: "pill", color: "white", onClick: function () { return _this.changePage(n); } }, n); }),
                pages - page > 3 && React.createElement(Dropdown, { key: "next_" + page, options: range(pages - (pages - page - 4), pages + 1).map(function (n) { return ({
                        children: getConfigVar("PAGE") + " " + n,
                        onClick: function () { return _this.changePage(n); }
                    }); }) },
                    React.createElement(Tooltip, { label: getConfigVar("PAGES") },
                        React.createElement(Button, { shape: "pill", color: "white" },
                            React.createElement(FontAwesomeIcon, { icon: faEllipsisH })))),
                page < pages && React.createElement(Tooltip, { label: getConfigVar("LAST_PAGE") },
                    React.createElement(Button, { shape: "pill", color: "white", onClick: function () { return _this.changePage(pages); } },
                        React.createElement(FontAwesomeIcon, { icon: faAnglesRight }))));
        };
        _this.getData = function () {
            var page = _this.state.page, items = _this.getFilteredData(), pagination = _this.props.pagination;
            if (!_this.showPagination())
                return items;
            return range((page - 1) * pagination, page * pagination).map(function (n) { return items.find(function (_, i) { return i === n; }); }).filter(function (e) { return !!e; });
        };
        _this.showPagination = function () {
            var pagination = _this.props.pagination;
            return pagination && pagination > 0 && pagination < _this.getFilteredData().length;
        };
        _this.getFilteredData = function () {
            var columns = _this.getColumns(), filters = _this.state.filters, items = _this.getOrderedData();
            var filteredItems = items;
            Object.keys(filters).filter(function (k) { var _a; return !!((_a = filters[k]) === null || _a === void 0 ? void 0 : _a.toString().trim()); }).forEach(function (k) {
                filteredItems = filteredItems.filter(function (item) {
                    var value = _this.getItemValue(item, k), column = columns.find(function (c) { var _a; return ((_a = c.filter) === null || _a === void 0 ? void 0 : _a.key) === k; }), filter = column.filter, colFilter = filters[k];
                    if (filter.type === "date") {
                        var format = filter.dateOrTimeFormat || Datepicker.DEFAULT_FORMAT, filterDate = moment(colFilter).format(format), itemDate = moment(value).format(format);
                        return filterDate === itemDate;
                    }
                    if (filter.type === "time") {
                        var format = filter.dateOrTimeFormat || Timepicker.DEFAULT_FORMAT.join(":"), filterDate = moment(colFilter).format(format), itemDate = moment(value).format(format);
                        return filterDate === itemDate;
                    }
                    if (!filter.type || filter.type === "string")
                        return !(value === null || value === void 0 ? void 0 : value.toString().trim()) || value.toString().toLowerCase().indexOf(colFilter.toLowerCase()) >= 0;
                    return value === colFilter;
                });
            });
            return filteredItems;
        };
        _this.getOrderedData = function () {
            var data = _this.props.data, columns = _this.getColumns(), orders = _this.state.orders.reverse(), items = data.map(function (item, index) { return ({ item: item, index: index }); });
            var orderedItems = items;
            orders.forEach(function (order) {
                orderedItems = orderedItems.sort(function (a, b) {
                    var valueA = _this.getItemValue(a, order.key), valueB = _this.getItemValue(b, order.key), columnOrder = columns.find(function (c) { var _a; return ((_a = c.order) === null || _a === void 0 ? void 0 : _a.key) === order.key; }), _a = columnOrder.order, type = _a.type, dateOrTimeFormat = _a.dateOrTimeFormat, format = dateOrTimeFormat || (type === "date" ? Datepicker.DEFAULT_FORMAT : Timepicker.DEFAULT_FORMAT), realA = type === "date" || type === "time" ? moment(valueA, format).toDate().getTime() : valueA, realB = type === "date" || type === "time" ? moment(valueB, format).toDate().getTime() : valueB, ordered = [realA, realB].sort(type === "number" ? function (a, b) { return a.toString().localeCompare(b, undefined, { numeric: true }); } : undefined);
                    if (ordered[0] === ordered[1])
                        return 0;
                    if (order.type === "desc")
                        return ordered.indexOf(realA) === 0 ? 1 : -1;
                    return ordered.indexOf(realA) === 0 ? -1 : 1;
                });
            });
            return orderedItems;
        };
        _this.getItemValue = function (data, key) {
            if (key.indexOf(".") === -1)
                return data.item[key];
            var obj = data.item;
            key.split(".").forEach(function (piece) { return obj = obj[piece]; });
            return obj;
        };
        _this.changeFilter = function (key, value) {
            var _a;
            var _b = _this.state, page = _b.page, filters = _b.filters;
            if (page !== 1)
                _this.changePage(1);
            _this.setState({
                filters: __assign(__assign({}, filters), (_a = {}, _a[key] = value, _a))
            });
        };
        _this.setFilterKey = function (showingFilter) { return _this.setState({ showingFilter: showingFilter }); };
        _this.getOrder = function (key) { return _this.state.orders.find(function (o) { return o.key === key; }); };
        _this.toggleOrder = function (key) {
            var orders = _this.state.orders, current = _this.getOrder(key);
            var newOrders;
            if (!current)
                newOrders = orders.concat({ type: "asc", key: key });
            else if (current.type === "asc") {
                newOrders = orders.map(function (o) {
                    if (o.key === key)
                        return { key: key, type: "desc" };
                    return o;
                });
            }
            else
                newOrders = orders.filter(function (o) { return o.key !== key; });
            _this.setState({ orders: newOrders });
        };
        _this.export = function () {
            var dataType = "application/vnd.ms-excel", cols = _this.getColumns().filter(function (d) { return !!d.export; }), toExport = _this.getOrderedData().map(function (d) { return cols.map(function (c) { return c.export(d.item); }); }), table = document.createElement("table"), thead = document.createElement("thead"), tbody = document.createElement("tbody"), trH = document.createElement("tr"), downloadLink = document.createElement("a"), fileName = "table.xls";
            cols.forEach(function (col) {
                var th = document.createElement("th");
                th.style.border = "1px solid black";
                th.innerText = col.label;
                trH.appendChild(th);
            });
            toExport.forEach(function (col) {
                var tr = document.createElement("tr");
                col.forEach(function (col, i) {
                    var td = document.createElement("td");
                    td.style.border = "1px solid black";
                    td.style.textAlign = cols[i].align;
                    td.innerText = col === null || col === void 0 ? void 0 : col.toString();
                    tr.appendChild(td);
                });
                tbody.appendChild(tr);
            });
            thead.appendChild(trH);
            table.appendChild(thead);
            table.appendChild(tbody);
            document.body.appendChild(downloadLink);
            downloadLink.href = "data:".concat(dataType, ", ").concat(encodeURI("\uFEFF" + table.outerHTML));
            downloadLink.download = fileName;
            downloadLink.click();
            downloadLink.remove();
        };
        _this.mapChildren = function (children) {
            var columns = _this.getColumns();
            return React.Children.map(children, function (Component) {
                if (Component && Component.type && Component.type === ToolbarExportButton) {
                    if (!columns.some(function (c) { return !!c.export; }))
                        return React.createElement(React.Fragment, null);
                    return React.createElement(Tooltip, { label: getConfigVar("EXPORT") },
                        React.createElement(Button, { shape: "pill", color: "white", onClick: _this.export },
                            React.createElement(FontAwesomeIcon, { icon: faShareNodes, size: "lg" })));
                }
                else if (Component && Component.type && Component.type === TableOrderButton) {
                    if (!columns.some(function (c) { return !!c.order; }))
                        return React.createElement(React.Fragment, null);
                    return React.createElement(Dropdown, {
                        options: columns.filter(function (c) { return !!c.order; }).map(function (c) {
                            var key = c.order.key, cOrder = _this.getOrder(key);
                            return {
                                children: React.createElement(React.Fragment, null,
                                    React.createElement(FontAwesomeIcon, { icon: !cOrder ? faSort : cOrder.type === "asc" ? faSortDown : faSortUp, style: { marginRight: 5 } }),
                                    " ",
                                    c.label),
                                onClick: function () { return _this.toggleOrder(key); }
                            };
                        }),
                        children: React.createElement(Tooltip, { label: getConfigVar("ORDER") },
                            React.createElement(Button, { shape: "pill", color: "white" },
                                React.createElement(FontAwesomeIcon, { icon: faArrowUpShortWide, size: "lg" })))
                    });
                }
                else if (Component && Component.props && Component.props.children) {
                    return React.cloneElement(Component, __assign(__assign({}, Component.props), { children: _this.mapChildren(Component.props.children) }));
                }
                return Component;
            });
        };
        _this.getColumns = function () { return filterChildrenOfType(_this, TableColumn).map(function (c) { return c.props; }); };
        _this.render = function () {
            var _a, _b, _c;
            var _d = _this.props, className = _d.className, data = _d.data, style = _d.style, selectionMode = _d.selectionMode, onDoubleClickRow = _d.onDoubleClickRow, isSelectable = _d.isSelectable, onSelectionChange = _d.onSelectionChange, rowStyle = _d.rowStyle, rowClass = _d.rowClass, pageData = _this.getData(), columns = _this.getColumns(), toolbar = filterChildrenOfType(_this, TableToolbar), dataSelectable = data.filter(function (d) { return !isSelectable || isSelectable(d); }), columsTotal = onSelectionChange ? columns.length + 1 : columns.length, _e = _this.state, checkedItems = _e.checkedItems, showingFilter = _e.showingFilter, filters = _e.filters, scrollEnded = _e.scrollEnded;
            return React.createElement("div", { className: "dolfo-table-container", onScrollCapture: _this.checkContainerScroll, ref: function (r) { return _this.target = r; } },
                React.createElement("table", { className: concatClassNames("dolfo-table", className), style: style },
                    React.createElement("thead", null,
                        toolbar.length > 0 && React.createElement("tr", null,
                            React.createElement("th", { colSpan: columsTotal, className: concatClassNames("dolfo-table-toolbar", (_a = toolbar[0]) === null || _a === void 0 ? void 0 : _a.props.className), style: (_b = toolbar[0]) === null || _b === void 0 ? void 0 : _b.props.style }, _this.mapChildren((_c = toolbar[0]) === null || _c === void 0 ? void 0 : _c.props.children))),
                        React.createElement("tr", null,
                            onSelectionChange && React.createElement("th", { style: { width: 0 } }, selectionMode === "multiple" && React.createElement(Checkbox, { checked: checkedItems.length === dataSelectable.length, disabled: dataSelectable.length === 0, onChange: _this.checkAll })),
                            columns.map(function (c, i) {
                                var filter = c.filter, label = c.label;
                                return React.createElement("th", { key: i, style: { width: c.width, maxWidth: c.width } },
                                    filter ? React.createElement(React.Fragment, null,
                                        showingFilter !== filter.key ? label : "",
                                        React.createElement("div", { className: concatClassNames("dolfo-table-filter", showingFilter === filter.key ? "showing" : "") }, c.filter.type === "date" ?
                                            React.createElement(Datepicker, { defaultValue: filters[filter.key] ? new Date(filters[filter.key]) : null, dateFormat: filter.dateOrTimeFormat, onChange: function (v) { return _this.changeFilter(filter.key, v === null || v === void 0 ? void 0 : v.toString()); }, onBlur: function () { return _this.setFilterKey(); } })
                                            : c.filter.type === "time" ?
                                                React.createElement(Timepicker, { defaultValue: filters[filter.key] ? new Date(filters[c.filter.key]) : null, timeFormat: filter.dateOrTimeFormat, onChange: function (v) { return _this.changeFilter(filter.key, v === null || v === void 0 ? void 0 : v.toString()); }, onBlur: function () { return _this.setFilterKey(); } })
                                                : React.createElement(Input, { autoFocus: true, type: filter.type === "number" ? "number" : "text", defaultValue: filters[filter.key], onChange: function (v) { return _this.changeFilter(filter.key, v); }, onBlur: function () { return _this.setFilterKey(); } }))) : label,
                                    !!filter && showingFilter !== filter.key && React.createElement(Tooltip, { label: getConfigVar("FILTER") },
                                        React.createElement(Button, { color: "white", shape: "pill", className: "dolfo-table-filter-btn", size: "small", onClick: function () { return _this.setFilterKey(c.filter.key); } },
                                            React.createElement(FontAwesomeIcon, { icon: faFilter }))));
                            }))),
                    React.createElement("tbody", null,
                        pageData.length > 0 ? pageData.map(function (d) { return React.createElement("tr", { key: d.index, onDoubleClick: function () {
                                if (onDoubleClickRow)
                                    onDoubleClickRow(d.item);
                            }, className: checkedItems.includes(d.index) ? "focused" : "" },
                            onSelectionChange && React.createElement("td", { className: concatClassNames("align-center", rowClass === null || rowClass === void 0 ? void 0 : rowClass(d.item, null)), style: __assign({ width: 0 }, rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle(d.item, null)) },
                                React.createElement(Checkbox, { checked: checkedItems.includes(d.index), disabled: isSelectable && !isSelectable(d.item), onChange: function () { return _this.changeSelection(d.index); } })),
                            columns.map(function (c, i2) {
                                var _a;
                                return React.createElement("td", { key: d.index + "-" + i2, className: concatClassNames("align-" + (c.align || "left"), rowClass === null || rowClass === void 0 ? void 0 : rowClass(d.item, c)), style: __assign(__assign({}, rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle(d.item, c)), { width: c.width, maxWidth: c.width }) }, (_a = columns[i2]) === null || _a === void 0 ? void 0 : _a.children(d.item));
                            })); }) : React.createElement("tr", null,
                            React.createElement("td", { colSpan: columsTotal, className: "no-results" }, getConfigVar("NO_RESULTS"))),
                        _this.showPagination() && React.createElement("tr", { className: concatClassNames("dolfo-table-pagination", scrollEnded ? "ended" : "") },
                            React.createElement("td", { colSpan: columsTotal }, _this.getPaginationButtons())))));
        };
        var isSelectedDefault = props.isSelectedDefault, data = props.data, checkedItems = data.map(function (item, index) { return ({ item: item, index: index }); }).filter(function (_a) {
            var item = _a.item;
            return isSelectedDefault ? isSelectedDefault(item) : false;
        }).map(function (_a) {
            var index = _a.index;
            return index;
        });
        _this.state = {
            checkedItems: checkedItems,
            page: 1,
            filters: {},
            showingFilter: null,
            orders: [],
            scrollEnded: false
        };
        return _this;
    }
    return Table;
}(React.Component));
export { Table };
/** Defines the columns of the table */
var TableColumn = /** @class */ (function (_super) {
    __extends(TableColumn, _super);
    function TableColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableColumn;
}(EmptyComponent));
export { TableColumn };
/** If put as a children of Table, shows a toolbar on top of the table */
var TableToolbar = /** @class */ (function (_super) {
    __extends(TableToolbar, _super);
    function TableToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableToolbar;
}(EmptyComponent));
export { TableToolbar };
/** If put as a children of TableToolbar as a children, a button to order the column is shown in the toolbar */
var TableOrderButton = /** @class */ (function (_super) {
    __extends(TableOrderButton, _super);
    function TableOrderButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableOrderButton;
}(EmptyComponent));
export { TableOrderButton };
/** If put as a children of TableToolbar as a children, a button to export the datasource is shown in the toolbar */
var ToolbarExportButton = /** @class */ (function (_super) {
    __extends(ToolbarExportButton, _super);
    function ToolbarExportButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ToolbarExportButton;
}(EmptyComponent));
export { ToolbarExportButton };
